import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ThemeService {
    constructor() {
        this.setInitialTheme();
    }
    public theme = signal(localStorage.getItem('theme') || window.matchMedia('(prefers-color-scheme: dark)') ? 'guideline-dark' : 'guideline-light');

    setTheme(theme: string) {
        const themeLink = document.querySelector('html');
        if (themeLink) {
            themeLink.classList.remove('guideline-dark', 'guideline-light');
            themeLink.classList.add(theme);
        }
        this.theme.set(theme);
        localStorage.setItem('theme', theme);
    }
    setInitialTheme() {
        const storeTheme = localStorage.getItem('theme');
        const theme =
            storeTheme ? storeTheme
            : window.matchMedia('(prefers-color-scheme: dark)') ? 'guideline-dark'
            : 'guideline-light';
        this.setTheme(theme);
    }
}
